import { Injectable } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

export interface Validation {
  valid: Boolean;
  errors: String[];
  warnings: String[];
}

@Injectable({
  providedIn: 'root'
})
export class AddressValidationService {
  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly translateService: TranslateService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }

  public validateAddress(address): Validation {
    const errors = [];
    const warnings = [];

    if (address) {
      if (!address.postalCode) {
        warnings.push(this.translateService.instant('ADDRESS_VALIDATION.POSTAL_CODE'));
      }

      if (!address.state) {
        errors.push(this.translateService.instant('ADDRESS_VALIDATION.STATE'));
      }

      if (!address.city) {
        errors.push(this.translateService.instant('ADDRESS_VALIDATION.CITY'));
      }

      if (!address.streetName) {
        warnings.push(this.translateService.instant('ADDRESS_VALIDATION.STREET'));
      }

      if (!address.neighborhood) {
        warnings.push(this.translateService.instant('ADDRESS_VALIDATION.NEIGHBORHOOD'));
      }

      if (!address.number) {
        warnings.push(this.translateService.instant('ADDRESS_VALIDATION.NUMBER'));
      }
    }

    return {
      valid: !errors.length,
      errors: errors.length ? errors : null,
      warnings: warnings.length ? warnings : null
    };
  }
}
